import { clientInfo } from "../resources";

const vi = {
    general: {
        desc: "Miễn phí",
        desc2: "Xem Thể Thao Trực Tiếp",
        desc3: "trên điện thoại của bạn!",
        download: "TẢI ỨNG DỤNG",
        availableDevice: "Chỉ khả dụng trên Android",
        copyRight: `© ${clientInfo.brand}. Bảo lưu mọi quyền.`,
        downloadTitle: "Tải APK",
        downloadText: "Liên kết tải xuống"
    },
    step: {
        title: "Cách tải và cài đặt",
        step_1: "BƯỚC 1",
        step_1_desc: `Gỡ cài đặt phiên bản cũ của ${clientInfo.brand} nếu vẫn còn trên điện thoại của bạn`,
        step_2: "BƯỚC 2",
        step_2_btn: "Tải xuống",
        step_2_desc: `Tệp APK mới của ${clientInfo.brand}`,
        step2_dl_collapse: {
            title: "Liên kết tải APK",
            dl_1: "Liên kết tải"
        },
        step_3: "BƯỚC 3",
        step_3_desc: `Nhấn <b>Vẫn tải xuống</b> để tiếp tục`,
        step_4: "BƯỚC 4 <b>Tùy tình huống</b>",
        step_4_desc: "Thay đổi cài đặt bảo mật để cho phép điện thoại của bạn cài đặt ứng dụng từ nguồn không xác định",
        step_5: "BƯỚC 5 <b>Tùy tình huống</b>",
        step_5_desc: "Nếu bạn đang sử dụng Chrome làm trình duyệt mặc định, hãy bật nút gạt <b>Chrome</b> để tiếp tục",
        step_5_desc_1: "Nếu bạn đã tải tệp APK, hãy bật nút gạt <b>Tệp của tôi</b> thay vào đó",
        step_6: "BƯỚC 6",
        step_6_desc: `Nhấn <b>"Cài đặt"</b> để bắt đầu cài đặt ứng dụng ${clientInfo.brand} mới`,
        step_7: "BƯỚC 7",
        step_7_desc: `Hoàn tất! Mở ứng dụng ${clientInfo.brand} và tận hưởng!`
    },
    ads_form: {
        dialog: {
            title: "Cảm ơn bạn",
            desc: "Chúng tôi sẽ liên hệ lại với bạn sớm nhất có thể",
            btn: "OK"
        },
        boost: {
            title: 'Khi nào nên quảng bá?'
        },
        title: "Quảng cáo với chúng tôi",
        required: "Bắt buộc",
        invalid: "Định dạng không hợp lệ",
        name: "Tên",
        email: "Email",
        contact: "Liên hệ",
        product: "Sản phẩm muốn quảng cáo",
        select: "Vui lòng chọn 1 hoặc nhiều mục",
        type: {
            fashion: "Thời trang",
            car: "Đại lý ô tô",
            flower: "Cửa hàng hoa",
            accessory: "Phụ kiện",
            other: "Khác"
        },
        desc: "Mô tả sản phẩm của bạn",
        remark: "Ghi chú",
        require: "Trường bắt buộc",
        submit: "GỬI",
        backToApp: "QUAY LẠI ỨNG DỤNG"
    },
    support: {
        title: 'Cần hỗ trợ?',
        desc: 'Đội ngũ hỗ trợ khách hàng của chúng tôi luôn sẵn sàng giúp bạn!',
        desc2: `Để lại tin nhắn & chúng tôi sẽ phản hồi bạn.`,
        name: 'Tên',
        email: 'Email',
        issue: 'Vấn đề',
        options: {
            feedback: 'Phản hồi',
            request: 'Yêu cầu tính năng',
            bug: 'Lỗi',
            others: 'Khác'
        },
        details: 'Chi tiết',
        placehoder: 'Nhập thông tin của bạn tại đây',
        submit: "GỬI"
    },
    aboutUs: {
        aboutUs: {
            title: 'Về chúng tôi',
            desc: `Chào mừng đến với {{boldText}}, điểm đến hàng đầu để phát trực tiếp và chinh phục thế giới e-sports. Dù bạn đam mê bóng đá điện tử, {{boldText}} là nền tảng lý tưởng để theo dõi nội dung chất lượng cao và phát triển kỹ năng vượt bậc.`
        },
        platform: {
            title: 'Nền tảng của chúng tôi',
            desc: `{{boldText}} được thiết kế để đáp ứng nhu cầu ngày càng tăng về nội dung e-sports chất lượng cao. Tập trung vào bóng đá điện tử, nền tảng của chúng tôi cung cấp một loạt tính năng, bao gồm:`,
            point1: '{{boldText}} Xem các trận đấu trực tiếp với các tuyển thủ và đội hàng đầu trên toàn thế giới. Hình ảnh chất lượng cao giúp bạn không bỏ lỡ bất kỳ khoảnh khắc nào.',
            point2: `{{boldText}} Học hỏi từ các cao thủ thông qua hướng dẫn độc quyền, phân tích chiến lược và mẹo chuyên nghiệp. Nội dung được chọn lọc để hỗ trợ người dùng nâng cao kỹ năng, dù là người mới hay chuyên gia.`,
            // point3: `Cộng đồng tương tác: Tham gia cộng đồng game thủ toàn cầu cùng đam mê. Trò chuyện trực tiếp khi xem, tham gia diễn đàn và kết nối với những người cùng sở thích.`
        },
        why: {
            title: 'Vì sao chọn VECTORSPORT?',
            desc: `Dù bạn là người xem bình thường hay game thủ đang vươn lên chuyên nghiệp, {{boldText}} đều có điều gì đó dành cho bạn. Đăng ký ngay để bắt đầu xem, học hỏi và kết nối với cộng đồng e-sports toàn cầu. Cùng nhau, chúng ta sẽ nâng tầm kỹ năng của bạn.`
        },
        future: {
            title: "Kế hoạch tương lai",
            desc: `Chúng tôi rất hào hứng thông báo rằng {{boldText}} đang mở rộng! Bên cạnh bóng đá điện tử, chúng tôi sẽ phát triển nội dung cho bóng rổ điện tử và các tựa game e-sports phổ biến khác. Hãy theo dõi những tính năng mới và cập nhật để nâng cao trải nghiệm chơi game của bạn.`
        },
        promote: {
            title: 'Quảng bá câu lạc bộ của bạn',
            desc: `Nếu bạn là thành viên của một câu lạc bộ thể thao và muốn quảng bá hoạt động của mình, {{boldText}} là nền tảng tuyệt vời để giới thiệu đội của bạn và các sự kiện. Hãy liên hệ với chúng tôi để khám phá cơ hội hợp tác và tăng độ nhận diện trong cộng đồng e-sports.`
        }
    },
    err: {
        timeout: "Yêu cầu đã hết thời gian chờ"
    }
}

export default vi;